var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 0.164062C5.21875 -0.0546875 5.59375 -0.0546875 5.84375 0.164062C6.6875 0.976562 7.5 1.85156 8.25 2.78906C8.59375 2.35156 9 1.85156 9.40625 1.44531C9.65625 1.22656 10.0312 1.22656 10.2812 1.44531C11.375 2.47656 12.2812 3.85156 12.9375 5.13281C13.5625 6.41406 14 7.72656 14 8.63281C14 12.6328 10.875 15.9766 7 15.9766C3.0625 15.9766 0 12.6328 0 8.63281C0 7.44531 0.53125 5.97656 1.40625 4.50781C2.28125 3.03906 3.5 1.50781 4.96875 0.164062ZM7.03125 12.9766C7.84375 12.9766 8.53125 12.7578 9.1875 12.3203C10.5 11.4141 10.8438 9.57031 10.0625 8.13281C9.9375 7.85156 9.5625 7.82031 9.375 8.07031L8.5625 8.97656C8.375 9.22656 8 9.22656 7.8125 8.97656C7.28125 8.32031 6.375 7.13281 5.84375 6.47656C5.65625 6.22656 5.28125 6.22656 5.0625 6.47656C4 7.78906 3.46875 8.63281 3.46875 9.57031C3.5 11.7266 5.0625 12.9766 7.03125 12.9766Z",
    fill: "#E66E2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.e455be328bc71a87f19dbd9516f69393.svg";
export { ForwardRef as ReactComponent };